import React from "react";

import { EditOutlined } from "@mui/icons-material";
import { Button, Divider } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import EnableDisableButton from "components/Shared/EnableDisableButton";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import AdjustmentBasicDetail from "./AdjustmentComponents/AdjustmentBasicDetail";
import {
  useGetAdjustmentDetailQuery,
  useUpdateAdjustmentMutation,
} from "store/services/PaymentsApi/adjustmentApi";
import {
  AdjustmentDetailContext,
  useAdjustmentDetailContext,
} from "contexts/PaymentContexts/AdjustmentContext";
import { useAuth } from "hooks";

const AdjustmentDetailScreen = () => {
  const { isVendor } = useAuth();

  const { id } = useParams();

  const breadcrumb = [
    {
      title: "Adjustment",
      path: !isVendor
        ? "/app/crm/adjustment/list"
        : "/app/vendor/adjustment/list",
    },
    { title: "Adjustment Detail" },
  ];

  const {
    data: adjustmentDetail,
    isLoading: loadingAdjustment,
    error,
  } = useGetAdjustmentDetailQuery(id);

  return (
    <AdjustmentDetailContext.Provider
      value={{ adjustmentDetail, loadingAdjustment }}
    >
      <BreadcrumbLayout
        breadcrumbs={breadcrumb}
        isBusy={loadingAdjustment}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />
        <BreadcrumbLayout.Paper>
          <AdjustmentBasicDetail />
          <Divider />
          {/* Add other sections like audit logs, notes, etc. if needed */}
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </AdjustmentDetailContext.Provider>
  );
};

export default AdjustmentDetailScreen;

const PageActions = () => {
  const { isVendor, isAccountAdmin } = useAuth();
  const { adjustmentDetail, loadingAdjustment } = useAdjustmentDetailContext();
  const [updateAdjustment, { isLoading: updatingAdjustment }] =
    useUpdateAdjustmentMutation();

  const handleToggleStatus = async () => {
    try {
      await updateAdjustment({
        _id: adjustmentDetail?._id,
        isActive: !adjustmentDetail?.isActive,
      }).unwrap();
      toast.info(
        `Adjustment ${adjustmentDetail?.isActive ? "Disabled" : "Enabled"}!`
      );
    } catch (error) {
      toast.error(error?.data?.message ?? "Could not update status");
    }
  };

  return (
    <>
      {!isVendor && (
        <div className="flex space-x-4">
          {isAccountAdmin && (
            <EnableDisableButton
              isActive={adjustmentDetail?.isActive}
              loading={loadingAdjustment || updatingAdjustment}
              onClick={handleToggleStatus}
            />
          )}
          <Link to={`/app/crm/adjustment/${adjustmentDetail?._id}/edit`}>
            <Button startIcon={<EditOutlined />} variant="contained">
              Edit
            </Button>
          </Link>
        </div>
      )}
    </>
  );
};
